<template>
  <div>
    <div style="margin-bottom: 1rem">
      <el-button size="mini" @click="handleAdd" type="primary">添加权限</el-button>
      <el-radio-group v-model="filterType" size="mini" @change="getPermissionList" style="margin-left: 10px;">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button label="api">API权限</el-radio-button>
        <el-radio-button label="menu">菜单权限</el-radio-button>
        <el-radio-button label="button">按钮权限</el-radio-button>
      </el-radio-group>
    </div>

    <el-alert
        title="拖动提示"
        type="info"
        :closable="false"
        style="margin-bottom: 15px;">
      <template slot="default">
        <div style="line-height: 1.8;">
          <i class="el-icon-info"></i> 可以通过拖动节点来调整权限的层级和排序：
          <ul style="margin: 5px 0; padding-left: 20px;">
            <li><b>拖到节点前/后</b>：与该节点成为兄弟节点（同级排序）</li>
            <li><b>拖到节点内部</b>：成为该节点的子节点（改变归类）</li>
            <li><b>注意</b>：按钮权限不能作为父节点</li>
          </ul>
        </div>
      </template>
    </el-alert>

    <el-tree
        :data="treeData"
        :props="treeProps"
        :default-expand-all="false"
        :expand-on-click-node="false"
        node-key="id"
        draggable
        :allow-drop="allowDrop"
        :allow-drag="allowDrag"
        @node-drop="handleDrop"
        style="margin-top: 20px;">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span class="node-content">
          <span class="node-label">{{ data.name }}</span>
          <el-tag :type="getTypeTag(data.type)" size="mini" style="margin-left: 10px;">
            {{ getTypeText(data.type) }}
          </el-tag>
          <span class="node-code">{{ data.code }}</span>
          <span class="node-resource" v-if="data.resource">{{ data.resource }}</span>
          <el-tag v-if="data.method" size="mini" type="info" style="margin-left: 5px;">
            {{ data.method }}
          </el-tag>
        </span>
        <span class="node-actions">
          <el-button
              type="text"
              size="mini"
              @click.stop="handleEdit(data)">
            编辑
          </el-button>
          <el-button
              type="text"
              size="mini"
              style="color: #F56C6C;"
              @click.stop="handleDelete(data)">
            删除
          </el-button>
        </span>
      </span>
    </el-tree>

    <!-- 添加/编辑权限对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="formRules" ref="form" label-width="120px">
        <el-form-item label="权限名称" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="权限编码" prop="code">
          <el-input v-model="form.code" autocomplete="off" :disabled="editMode"></el-input>
        </el-form-item>
        <el-form-item label="权限类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择" style="width: 100%;" :disabled="editMode">
            <el-option label="API权限" value="api"></el-option>
            <el-option label="菜单权限" value="menu"></el-option>
            <el-option label="按钮权限" value="button"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源路径" v-if="form.type === 'api' || form.type === 'menu'">
          <el-input v-model="form.resource" autocomplete="off" placeholder="如: /api/v1/user 或 /users"></el-input>
        </el-form-item>
        <el-form-item label="请求方法" v-if="form.type === 'api'">
          <el-select v-model="form.method" placeholder="请选择" clearable style="width: 100%;">
            <el-option label="无（父节点/分组/所有方法）" value=""></el-option>
            <el-option label="GET" value="GET"></el-option>
            <el-option label="POST" value="POST"></el-option>
            <el-option label="PUT" value="PUT"></el-option>
            <el-option label="DELETE" value="DELETE"></el-option>
            <el-option label="PATCH" value="PATCH"></el-option>
          </el-select>
          <div style="color: #909399; font-size: 12px; margin-top: 5px;">
            <i class="el-icon-info"></i> 为空时可作为API分组父节点，或匹配所有请求方法
          </div>
        </el-form-item>
        <el-form-item label="父级权限">
          <el-cascader
            v-model="form.parent_id"
            :options="filteredPermissionTreeOptions"
            :props="cascaderProps"
              clearable
            placeholder="请选择父级权限（不选则为顶级）"
            style="width: 100%;">
          </el-cascader>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="9999"></el-input-number>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.description" type="textarea" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'Permissions',
  data() {
    return {
      treeData: [],
      permissionTreeOptions: [],
      filterType: '',
      dialogFormVisible: false,
      editMode: false,
      form: {
        name: '',
        code: '',
        type: 'api',
        resource: '',
        method: '',
        description: '',
        parent_id: 0,
        sort: 0
      },
      formRules: {
        name: [
          { required: true, message: '请输入权限名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入权限编码', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择权限类型', trigger: 'change' }
        ]
      },
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: false
      },
      treeProps: {
        children: 'children',
        label: 'name'
      }
    };
  },
  computed: {
    dialogTitle() {
      return this.editMode ? '编辑权限' : '添加权限';
    },
    // 根据当前表单的权限类型过滤父级权限选项
    filteredPermissionTreeOptions() {
      if (!this.form.type) {
        return this.permissionTreeOptions;
      }
      
      // 过滤掉按钮类型的权限（按钮权限不能作为父级）
      // 同时根据当前类型过滤：同类型或API/菜单类型可以作为父级
      return this.filterParentOptions(this.permissionTreeOptions, this.form.type);
    }
  },
  mounted() {
    this.getPermissionList();
    this.getPermissionTree();
  },
  watch: {
    // 监听表单权限类型的变化，自动清空不匹配的父级权限选择
    'form.type': function(newType, oldType) {
      if (newType && oldType && newType !== oldType && this.form.parent_id) {
        // 检查当前选择的父级权限是否还在过滤后的选项中
        const isParentValid = this.checkParentIdInOptions(this.form.parent_id, this.filteredPermissionTreeOptions);
        
        if (!isParentValid) {
          // 如果父级权限不在可选列表中，清空选择
          this.form.parent_id = 0;
          this.$message.warning('权限类型已更改，父级权限已被重置');
        }
      }
    }
  },
  methods: {
    getPermissionList() {
      const params = {};
      
      if (this.filterType) {
        params.type = this.filterType;
      }
      
      this.http.fetchGet(this.api.permission_tree, params).then((res) => {
        if (res.data.code === 200) {
          let data = res.data.data || [];
          
          // 如果有筛选类型，递归过滤树形数据
          if (this.filterType) {
            data = this.filterTreeByType(data, this.filterType);
          }
          
          this.treeData = data;
          this.permissionTreeOptions = res.data.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('获取权限树失败');
      });
    },
    getPermissionTree() {
      this.http.fetchGet(this.api.permission_tree).then((res) => {
        if (res.data.code === 200) {
          this.permissionTreeOptions = res.data.data || [];
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 递归过滤树形数据
    filterTreeByType(data, type) {
      let result = [];
      
      for (let item of data) {
        let newItem = { ...item };
        let hasMatchingChildren = false;
        
        // 递归处理子节点
        if (newItem.children && newItem.children.length > 0) {
          newItem.children = this.filterTreeByType(newItem.children, type);
          hasMatchingChildren = newItem.children.length > 0;
        }
        
        // 如果当前节点类型匹配，或者有匹配的子节点，则保留
        if (newItem.type === type || hasMatchingChildren) {
          result.push(newItem);
        }
      }
      
      return result;
    },
    // 根据当前选择的权限类型过滤父级权限选项
    filterParentOptions(data, currentType) {
      let result = [];
      
      for (let item of data) {
        // 按钮权限不能作为父级
        if (item.type === 'button') {
          continue;
        }
        
        let newItem = { ...item };
        
        // 递归处理子节点
        if (newItem.children && newItem.children.length > 0) {
          newItem.children = this.filterParentOptions(newItem.children, currentType);
        }
        
        // 根据当前类型过滤父级选项
        // API权限可以选择API类型的父级
        // 菜单权限可以选择菜单类型的父级
        // 按钮权限可以选择菜单或API类型的父级
        if (currentType === 'button') {
          // 按钮权限可以选择API或菜单作为父级
          if (item.type === 'api' || item.type === 'menu') {
            result.push(newItem);
          }
        } else {
          // API和菜单权限只能选择同类型作为父级
          if (item.type === currentType) {
            result.push(newItem);
          }
        }
      }
      
      return result;
    },
    // 检查给定的父级ID是否在选项树中存在
    checkParentIdInOptions(parentId, options) {
      for (let option of options) {
        if (option.id === parentId) {
          return true;
        }
        
        if (option.children && option.children.length > 0) {
          if (this.checkParentIdInOptions(parentId, option.children)) {
            return true;
          }
        }
      }
      
      return false;
    },
    getTypeTag(type) {
      const typeMap = {
        'api': 'success',
        'menu': 'primary',
        'button': 'warning'
      };
      return typeMap[type] || '';
    },
    getTypeText(type) {
      const typeMap = {
        'api': 'API',
        'menu': '菜单',
        'button': '按钮'
      };
      return typeMap[type] || type;
    },
    handleAdd() {
      this.editMode = false;
      this.form = {
        name: '',
        code: '',
        type: 'api',
        resource: '',
        method: '',
        description: '',
        parent_id: 0,
        sort: 0
      };
      this.dialogFormVisible = true;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    handleEdit(row) {
      this.editMode = true;
      this.form = {
        id: row.id,
        name: row.name,
        code: row.code,
        type: row.type,
        resource: row.resource,
        method: row.method,
        description: row.description,
        parent_id: row.parent_id || 0,
        sort: row.sort || 0
      };
      this.dialogFormVisible = true;
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.editMode) {
            // 更新权限
            this.http.fetchPut(this.api.permission_update + '/' + this.form.id, this.form).then((res) => {
              if (res.data.code === 200) {
                this.$message.success('更新成功');
                this.dialogFormVisible = false;
                this.getPermissionList();
                this.getPermissionTree();
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(err => {
              console.log(err);
              this.$message.error('更新失败');
            });
          } else {
            // 创建权限
            this.http.fetchPost(this.api.permission_create, this.form).then((res) => {
              if (res.data.code === 200) {
                this.$message.success('添加成功');
                this.dialogFormVisible = false;
                this.getPermissionList();
                this.getPermissionTree();
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(err => {
              console.log(err);
              this.$message.error('添加失败');
            });
          }
        }
      });
    },
    handleDelete(row) {
      this.$confirm(`确定要删除权限 ${row.name} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.http.fetchDel(this.api.permission_delete + '/' + row.id).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('删除成功');
            this.getPermissionList();
            this.getPermissionTree();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(err => {
          console.log(err);
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    // 允许拖动
    allowDrag() {
      // 所有节点都可以拖动
      return true;
    },
    // 允许放置
    allowDrop(draggingNode, dropNode, type) {
      // type 可以是 'prev'（前）, 'inner'（内部）, 'next'（后）
      
      // 不同类型的权限可以互相拖动和嵌套
      // 可以根据业务需求添加更多限制
      
      // 示例限制：按钮权限不能作为父节点
      if (type === 'inner' && dropNode.data.type === 'button') {
        return false;
      }
      
      return true;
    },
    // 拖动结束后的处理
    handleDrop(draggingNode, dropNode, dropType) {
      const dragData = draggingNode.data;
      let newParentId = 0;
      let newSort = 0;
      
      if (dropType === 'inner') {
        // 拖动到节点内部，成为其子节点
        newParentId = dropNode.data.id;
        
        // 计算新的排序值（放在子节点列表最后）
        if (dropNode.data.children && dropNode.data.children.length > 0) {
          const maxSort = Math.max(...dropNode.data.children.map(c => c.sort || 0));
          newSort = maxSort + 1;
        } else {
          newSort = 1;
        }
      } else {
        // 拖动到节点前后，与其成为兄弟节点
        newParentId = dropNode.data.parent_id || 0;
        
        // 计算新的排序值
        if (dropType === 'before') {
          newSort = dropNode.data.sort - 0.5;
        } else {
          newSort = dropNode.data.sort + 0.5;
        }
      }
      
      // 调用后端API更新权限的parent_id和sort
      this.updatePermissionPosition(dragData.id, newParentId, Math.round(newSort));
    },
    // 获取兄弟节点
    getSiblings(parentId) {
      const findSiblings = (nodes, targetParentId) => {
        let result = [];
        
        for (let node of nodes) {
          if (node.parent_id === targetParentId) {
            result.push(node);
          }
          
          if (node.children && node.children.length > 0) {
            result = result.concat(findSiblings(node.children, targetParentId));
          }
        }
        
        return result;
      };
      
      return findSiblings(this.treeData, parentId);
    },
    // 更新权限位置
    updatePermissionPosition(permissionId, parentId, sort) {
      // 从树中查找完整的权限数据
      const permission = this.findPermissionById(this.treeData, permissionId);
      
      if (!permission) {
        this.$message.error('找不到权限数据');
        this.getPermissionList();
        return;
      }
      
      // 构建完整的更新数据，保留所有原有字段
      const data = {
        name: permission.name,
        code: permission.code,
        type: permission.type,
        resource: permission.resource || '',
        method: permission.method || '',
        description: permission.description || '',
        parent_id: parentId,
        sort: sort
      };
      
      this.http.fetchPut(this.api.permission_update + '/' + permissionId, data).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('位置更新成功');
          // 重新获取权限树以确保数据同步
          this.getPermissionList();
          this.getPermissionTree();
        } else {
          this.$message.error(res.data.msg || '位置更新失败');
          // 更新失败，刷新树以恢复原状
          this.getPermissionList();
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('位置更新失败');
        // 更新失败，刷新树以恢复原状
        this.getPermissionList();
      });
    },
    // 递归查找权限节点
    findPermissionById(nodes, id) {
      for (let node of nodes) {
        if (node.id === id) {
          return node;
        }
        
        if (node.children && node.children.length > 0) {
          const found = this.findPermissionById(node.children, id);
          if (found) {
            return found;
          }
        }
      }
      
      return null;
    }
  }
}
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.node-content {
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.node-label {
  font-weight: 600;
  margin-right: 8px;
  color: #303133;
}

.node-code {
  color: #909399;
  font-size: 12px;
  margin-left: 8px;
  font-family: 'Courier New', monospace;
}

.node-resource {
  color: #67C23A;
  font-size: 12px;
  margin-left: 10px;
  font-family: 'Courier New', monospace;
}

.node-actions {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.el-tree {
  background-color: #fff;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 10px;
}

::v-deep .el-tree-node__content {
  height: 40px;
  line-height: 40px;
}

::v-deep .el-tree-node__content:hover {
  background-color: #F5F7FA;
}

::v-deep .el-tree-node__expand-icon {
  font-size: 16px;
  color: #606266;
}

/* 拖动相关样式 */
::v-deep .el-tree-node.is-drop-inner > .el-tree-node__content {
  background-color: #409EFF;
  color: white;
}

::v-deep .el-tree-node__content {
  cursor: move;
}

::v-deep .el-tree-node.is-dragging {
  opacity: 0.5;
}

::v-deep .el-tree-node.is-drop-inner > .el-tree-node__content .el-tag {
  background-color: white;
  color: #409EFF;
  border-color: white;
}

/* 拖动时的占位符样式 */
::v-deep .el-tree__drop-indicator {
  height: 2px;
  background-color: #409EFF;
}

/* 隐藏没有子节点的节点的展开图标 - 多种选择器确保生效 */
::v-deep .el-tree-node.is-leaf > .el-tree-node__content > .el-tree-node__expand-icon {
  visibility: hidden !important;
  cursor: default !important;
}

::v-deep .el-tree-node.is-leaf .el-tree-node__expand-icon {
  visibility: hidden !important;
}

/* 针对Element UI的is-leaf图标类 */
::v-deep .el-icon-caret-right.is-leaf {
  display: none !important;
}

/* 通用方式：所有叶子节点的箭头图标 */
::v-deep div.el-tree-node.is-leaf > div.el-tree-node__content > i.el-tree-node__expand-icon {
  display: none !important;
}
</style>
